import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "text-h3 q-px-md q-pt-md q-pb-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cover-bar" }, null, -1)
const _hoisted_3 = { class: "row justify-center" }
const _hoisted_4 = { class: "col-8 q-pb-md" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxTab from "src/components/navigation/SfxTab.vue"
import SfxTabs from "src/components/navigation/SfxTabs.vue"
import SettingsConfiguration from "src/pages/manager/settings/SettingsConfiguration.vue"
import SettingsInformation from "src/pages/manager/settings/SettingsInformation.vue"
import { hideScrollbar, showScrollbar } from "src/util/functions/scroll"
import { reactive, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogUserSettings',
  setup(__props) {

const { t } = useI18n()
const { dialogRef, onDialogCancel } = useDialogPluginComponent()

const informationTab = t("sfxDialogUserSettings.tab_information")
const configurationTab = t("sfxDialogUserSettings.tab_configuration")

const activeTab = ref(informationTab)

const rightTabs = reactive([
  { name: informationTab, label: informationTab, disable: false },
  { name: configurationTab, label: configurationTab, disable: false },
])

//endregion

//region Setup Code

watch(
  () => activeTab.value,
  () => {
    hideScrollbar()
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-user-settings"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_layout, {
            container: "",
            view: "hHh lpr fFf"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_header, { class: "bg-white text-dark" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)("sfxDialogUserSettings.title")), 1),
                  _createVNode(SfxTabs, {
                    modelValue: activeTab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightTabs, (tab) => {
                        return (_openBlock(), _createBlock(SfxTab, {
                          key: tab,
                          label: tab.label,
                          name: tab.name,
                          disable: tab.disable,
                          class: "full-width",
                          noCaps: ""
                        }, null, 8, ["label", "name", "disable"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_page_container, {
                class: "full-height scroll-box",
                onScroll: _unref(showScrollbar),
                onScrollend: _unref(hideScrollbar)
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_q_page, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tab_panels, {
                        modelValue: activeTab.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
                        swipeable: "",
                        animated: "",
                        "transition-prev": "fade",
                        "transition-next": "fade",
                        "keep-alive": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tab_panel, { name: _unref(informationTab) }, {
                            default: _withCtx(() => [
                              _createVNode(SettingsInformation, { onCloseDialog: _unref(onDialogCancel) }, null, 8, ["onCloseDialog"])
                            ]),
                            _: 1
                          }, 8, ["name"]),
                          _createVNode(_component_q_tab_panel, { name: _unref(configurationTab) }, {
                            default: _withCtx(() => [
                              _createVNode(SettingsConfiguration)
                            ]),
                            _: 1
                          }, 8, ["name"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onScroll", "onScrollend"]),
              _createVNode(_component_q_footer, { class: "transparent" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(SfxBtn, {
                        onClick: _unref(onDialogCancel),
                        label: _unref(t)('sfxButtons.btn_close'),
                        class: "full-width"
                      }, null, 8, ["onClick", "label"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})